import * as types from "../../types/configSyncType";

const INITIAL_STATE = {
  companies: [],
  isLoading: false,
  error: false,
  errorMessage: "",
  stationConfig: {}
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case types.LOAD_CONFING_SYNC_COMPANIES:
      return {
        ...state,
        isLoading: true,
        error: false,
        errorMessage: "",
      };
    case types.SET_CONFIG_SYNC_COMPANIES:
      return {
        ...state,
        companies: payload,
        isLoading: false,
      };
    case types.CLEAR_CONFIG_SYNC_COMPANIES:
      return {
        ...state,
        ...INITIAL_STATE,
      };
    case types.ERROR_CONFIG_SYNC_COMPANIES:
      return {
        ...state,
        isLoading: false,
        error: false,
        errorMessage: payload,
      };
    case types.LOAD_STATIONS_CONFIG:
      return {
        ...state,
        stationConfig: { ...state.stationConfig, ...payload }
      }
    default:
      return state;
  }
};
